import { CmsArticleStatusesEnum } from '~/src/models/enums/cms.enum';
import { fallBackOrder } from '~/src/repositories/cms/constants/cms.constants';
import type { DictionaryInterface } from '~/src/repositories/cms/types/cms.sections.types';
import type {
    CmsFaqListArticleAttributeInterface,
    FaqListInterface,
} from '~/src/repositories/cms/entities/main/types/cms.faq-list.types';

export const getMappedFaqData = (
    data: DictionaryInterface<CmsFaqListArticleAttributeInterface>[] | [],
): FaqListInterface[] => {
    return (data?.[0]?.articles || [])
        .reduce<FaqListInterface[]>((faqItem, elem) => {
            if (elem?.status === CmsArticleStatusesEnum.PUBLISHED) {
                const faqList = elem.attributeCategories.ostalis_voprosy?.attributes;
                faqItem.push({
                    id: elem.id,
                    question: faqList?.question_title?.value || null,
                    answer: faqList?.question_answer?.value || null,
                    image: faqList?.question_image?.value || null,
                    order: elem?.order || fallBackOrder,
                });
            }
            return faqItem;
        }, [])
        .sort((item, elem) => (item?.order || fallBackOrder) - (elem?.order || fallBackOrder));
};